import { Directive, Input, OnInit, ComponentFactoryResolver, ChangeDetectorRef, Host, Self, ViewContainerRef, SimpleChange, SimpleChanges, ElementRef, Renderer2 } from '@angular/core';
import { PagedResultModel } from 'mm-web-core/common';
import { TotalTemplateComponent } from './total-template/total-template.component';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { setPagedResult } from './set-paged-result';
import { EntityApiClientFactory } from 'mm-web-core/http/enitty-api-client-factory';
import { EntityApiClient } from 'mm-web-core/http';
import { HttpRequestOptions } from 'mm-web-core/http/http-request-options';
import { filter, tap, take, takeUntil, takeWhile } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { setTableData } from './set-table-data';

@Directive({
  selector: '[mm-table]',
  exportAs: 'mmTable'
})
export class MmTableDirective<TModel, TQueryModel> implements OnInit {


  constructor(
    @Host() @Self() private nzTable: NzTableComponent,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private resover: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private apiFactory: EntityApiClientFactory
  ) {


  }

  ngOnInit(): void {
    const nzFrontPagination = this.nzTable.nzFrontPagination;
    const nzShowTotal = this.nzTable.nzShowTotal;
    const nzSize = this.nzTable.nzSize;
    const nzTableLayout = this.nzTable.nzTableLayout;
    this.nzTable.nzFrontPagination = false;
    var factory = this.resover.resolveComponentFactory(TotalTemplateComponent);
    var componentRef = this.viewContainerRef.createComponent(factory);
    this.nzTable.nzShowTotal = componentRef.instance.template;
    this.nzTable.nzSize = "small";
    this.nzTable.nzTableLayout = "fixed"
    this.nzTable.ngOnChanges({ nzFrontPagination: new SimpleChange(nzFrontPagination, this.nzTable.nzFrontPagination, true) });
    this.nzTable.ngOnChanges({ nzShowTotal: new SimpleChange(nzShowTotal, this.nzTable.nzShowTotal, true) });
    this.nzTable.ngOnChanges({ nzSize: new SimpleChange(nzSize, this.nzTable.nzSize, true) })
    this.nzTable.ngOnChanges({ nzTableLayout: new SimpleChange(nzSize, this.nzTable.nzTableLayout, true) })


    this.renderer.addClass(this.elementRef.nativeElement, "mm-table");

    // this.mmPagination$.subscribe(p => {
    //   const nzShowTotal = this.nzTable.nzShowTotal;

    //   if (p) {
    //     this.nzTable.nzShowTotal = undefined;
    //   }
    //   else {

    //     this.nzTable.nzShowTotal = componentRef.instance.template;

    //   }
    //   if (nzShowTotal != this.nzTable.nzShowTotal) {
    //     this.nzTable.ngOnChanges({ nzShowTotal: new SimpleChange(nzShowTotal, this.nzTable.nzShowTotal, true) });
    //   }

    // });


    this.nzTable.nzPageIndexChange.pipe(
      filter(() => this.api != undefined && this.entityName && !this.nzTable.nzFrontPagination),
      tap(i => this.changePage(i))
    ).subscribe();

  }


  get api(): EntityApiClient<TModel, TQueryModel> {

    return this.apiFactory.create<TModel, TQueryModel>(this.entityName)
  }




  queryModel: TQueryModel;
  async search(queryModel?: TQueryModel, options?: { showSpinning?: boolean, pagination?: boolean }) {
    await this.entityName$.pipe(filter(_ => _ != undefined), take(1)).toPromise();
    options = {
      ...{
        showSpinning: true,
        pagination: true
      },
      ...options
    }

    this.mmPagination$.next(options.pagination);
    if (options.pagination) {
      const result = await this.api.pagedQuery(queryModel, options).toPromise();
      setPagedResult(this.nzTable, result);
      this.queryModel = queryModel;
    }
    else {
      const data = await this.api.query(queryModel, options).toPromise();
      setTableData(this.nzTable, data);
    }

  }


  async refresh(options: HttpRequestOptions = undefined) {
    await this.entityName$.pipe(filter(_ => _ != undefined), take(1)).toPromise();
    const result = await this.api.pagedQuery(this.queryModel, options).toPromise();
    setPagedResult(this.nzTable, result);
  }

  async delete(item: TModel, options: HttpRequestOptions = undefined) {
    await this.entityName$.pipe(filter(_ => _ != undefined), take(1)).toPromise();
    await this.api.delete((<any>item).id, options).toPromise();
    await this.refresh();
  }

  async changePage(i: number) {

    const queryModel = {
      ...this.queryModel,
      ...{
        pageIndex: i
      }
    };
    const result = await this.api.pagedQuery(queryModel).toPromise();
    this.queryModel = queryModel;
    setPagedResult(this.nzTable, result);

  }
  get data(): TModel[] {
    return this.nzTable.data as TModel[];
  }



  @Input()
  set pagedData(_: PagedResultModel<TModel>) {
    setPagedResult(this.nzTable, _);
  }



  entityName$ = new BehaviorSubject<string>(undefined);
  @Input()
  set entityName(_: string) {
    this.entityName$.next(_)
  }
  get entityName() {
    return this.entityName$.value;
  }
  mmPagination$ = new BehaviorSubject<boolean>(false);

  @Input()
  mmPagination(_: boolean) {
    this.mmPagination$.next(_);

  }




}
